import { SessionStorage } from 'common/CookieStorage'
import { STORAGEKEYS } from 'enviroment/Keys'


// Funkcja pomocnicza która pobiera dane z BIKu oraz zapisuje je w sessionStorage
export const collectBikData = () => {
   const sessionStorage = new SessionStorage()

   const inputHDIM = document.getElementById('ptsuser_prefs2') as HTMLInputElement
   const JSC = window.ptadx.ptvalidate('ptsuser_prefs') ?? "" //Dodano na potrzeby BIK CFD
   const HDIM = inputHDIM?.value ?? "" //Dodano na potrzeby BIK CFD
   sessionStorage.add(STORAGEKEYS.JSC, JSC)
   sessionStorage.add(STORAGEKEYS.HDIM, HDIM)
}